// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

const styles = theme => ({
  container: {
    margin: '40px -20px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',

    [theme.breakpoints.down(549)]: {
      flexDirection: 'column',
      margin: '10px 0',
    },
  },
  inputContainer: {
    width: '100%',
    margin: '0 20px',

    [theme.breakpoints.down(549)]: {
      flexDirection: 'column',
      margin: 0,
    },
  },
  button: {
    margin: '4px 20px',

    [theme.breakpoints.down(549)]: {
      margin: 0,
    },
  }
});

export default styles;
